module.exports = __webpack_public_path__ + "img/29.b1a84bde.svg";